import { motion } from 'framer-motion';
import { Zap, Flame, Sparkles } from 'lucide-react';
import { useUser } from '../contexts/UserContext';

export const EnergyBar = ({ showLabel = true }) => {
  const { user } = useUser();
  const energy = user?.energy_level || 0;
  
  // Determine energy state and color
  const getEnergyState = () => {
    if (energy >= 80) return { label: 'Radiante', color: '#06D6A0', icon: Sparkles };
    if (energy >= 60) return { label: 'Energético', color: '#FFD166', icon: Flame };
    if (energy >= 40) return { label: 'Estable', color: '#4F8CFF', icon: Zap };
    if (energy >= 20) return { label: 'Cansado', color: '#B794F4', icon: Zap };
    return { label: 'Agotado', color: '#EF476F', icon: Zap };
  };

  const state = getEnergyState();
  const Icon = state.icon;

  return (
    <div className="flex items-center gap-3" data-testid="energy-bar">
      <div className="flex items-center gap-2">
        <motion.div
          animate={{ scale: [1, 1.2, 1] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <Icon className="w-5 h-5" style={{ color: state.color }} />
        </motion.div>
        {showLabel && (
          <span className="text-sm font-medium text-muted-foreground">{state.label}</span>
        )}
      </div>
      
      <div className="flex-1 h-2 bg-muted rounded-full overflow-hidden min-w-[80px]">
        <motion.div
          className="h-full rounded-full"
          style={{ backgroundColor: state.color }}
          initial={{ width: 0 }}
          animate={{ width: `${energy}%` }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        />
      </div>
      
      <span className="text-sm font-semibold min-w-[40px]" style={{ color: state.color }}>
        {energy}%
      </span>
    </div>
  );
};

export default EnergyBar;
